import { routeNameEcommerceVersion1 } from '../../constant';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../../image';
import {
  HeaderContainer,
  ShoppingCartIconStyled,
  MenuIconStyled,
  HeaderIcon
} from './styledComponent';

const Header = ({setIsOpen}: any) => {
  const navigate = useNavigate();
  return (
    <HeaderContainer>
      <MenuIconStyled onClick={() => setIsOpen(true)}/>
      <HeaderIcon src={Logo} onClick={() => navigate(routeNameEcommerceVersion1.HOMEPAGE)} />
      <ShoppingCartIconStyled onClick={() => navigate(routeNameEcommerceVersion1.CART)} />
    </HeaderContainer>
  )
}

export default Header;